import React from 'react'

import { Helmet } from 'react-helmet'

import './not-found.css'

const NotFound1 = (props) => {
  return (
    <div className="not-found1-container1">
      <Helmet>
        <title>Page not found - Rapid Testing Service</title>
      </Helmet>
      <img
        src="/rts-logo.png"
        alt="Rapid Testing Service"
        className="not-found1-logo"
      />
      <h3>OOPS! PAGE NOT FOUND</h3>
      <div className="not-found1-container2">
        <h1 className="not-found1-text2">404</h1>
      </div>
      <div className="not-found1-container3">
        <h2 className="not-found1-text3">
          WE ARE SORRY, BUT THE PAGE YOU REQUESTED WAS NOT FOUND
        </h2>
      </div>
      <a href="/" className="not-found1-link">
        Back to home
      </a>
    </div>
  )
}

export default NotFound1
